import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {CommonService} from '../../services/common.service';
import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material';
import {
  QuestionnairAssignementWizardDialogComponent
} from '../questionnair-assignement-wizard-dialog/questionnair-assignement-wizard-dialog.component';
import {ToastMessagesService} from '../../services/toast-messages.service';

@Component({
  styleUrls: ['./questionnaire-details.component.scss'],
  templateUrl: './questionnaire-details.component.html'
})
export class QuestionnaireDetailsComponent implements OnInit {
  detailsId: number;
  details: any;
  basicDetailsConfig: any;
  showBasicInfo = false;
  user: any;
  questions = [];
  isLoading: boolean;

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private commonService: CommonService,
              private matDialog: MatDialog,
              private router: Router,
              private toastMessagesService: ToastMessagesService) {
    this.isLoading = false;
  }

  public async ngOnInit(): Promise<void> {
    try {
      this.isLoading = true;
      await this.initUser();
      this.detailsId = await this.getDetailsId();
      this.details = await this.getDetails();
      this.questions = this.details.questions;
      await this.initBasicInfo();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  private async getDetailsId(): Promise<number> {
    return new Promise((resolve) => {
      this.activatedRoute.params.subscribe(params => {
        this.detailsId = +params.id;
        resolve(+params.id);
      });
    });
  }

  private async initBasicInfo() {
    this.basicDetailsConfig = {
      subtitle: [{
        title: 'Ενέργειες ερωτηματολογίου',
        value: ''
      }],
      title: 'Πληροφορίες ερωτηματολογίου'
    };

    await this.initializeActions();
  }

  private async initializeActions() {
    const toolTip = 'Η εντολή είναι ήδη ολοκληρωμένη';
    const actions = [];
    const action1 = {
      function: () => {
        this.openAssignWizard(0);
      },
      showAction: this.details.status_id === 1,
      title: 'Ανάθεση ερωτηματολογίου',
      icon: 'navigation',
      color: 'green',
      tooltip: this.details.status_id === 10 ? 'H εντολή είναι ήδη δρομολογημένη' : 'Η εντολή είναι ήδη ολοκληρωμένη'
    };
    const action2 = {
      function: () => {
        this.openAssignWizard(1);
      },
      showAction: this.details.status_id === 10,
      title: 'Ενημέρωση ανάθεσης',
      icon: 'edit',
      color: 'green',
      tooltip: this.details.status_id === 1 ? 'H εντολή δεν έχει ανατεθεί ακόμα' : 'Η εντολή είναι ήδη ολοκληρωμένη'
    };
    const action3 = {
      function: () => {
        this.editQuestionnaire();
      },
      showAction: this.details.status_id === 1,
      title: 'Επεξεργασία ερωτηματολογίου',
      icon: 'edit',
      color: '#013e81',
      tooltip: this.details.status_id === 10 ? 'H εντολή είναι ήδη δρομολογημένη' : 'Η εντολή είναι ήδη ολοκληρωμένη'
    };

    actions.push(action1, action2, action3);

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = this.commonService.showActions(this.user);
    } else {
      this.basicDetailsConfig.showActions = false;
    }
    this.showBasicInfo = true;
  }

  private async initUser() {
    this.user = await this.authService.getUser();
  }

  async getDetails() {
    try {
      return await this.commonService.getList(`questionnaire/${this.detailsId}`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  public openAssignWizard(mode: number) {
    const wizardDialog = this.matDialog.open(QuestionnairAssignementWizardDialogComponent, {
      hasBackdrop: false,
      data: {
        title: mode === 0 ? 'Ανάθεση ερωτηματολογίου' : 'Ενημέρωση ερωτηματολογίου',
        mode,
        categoryId: this.details.category.category_id,
        statusId: this.details.status_id,
        detailsId: this.detailsId
      }
    });

    wizardDialog.afterClosed().subscribe((res) => {
      if (res) {
        window.location.reload();
      }
    });
  }

  private async editQuestionnaire() {
    try {
      await this.router.navigate(['questionnaire-creator'], {queryParams: {id: this.detailsId}});
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }
}
